import React from "react";

import { Box, Grid } from "@material-ui/core";
import Form from "./Form";
import Subtitle from "./Subtitle";

const Filter: React.FC = () => {
    return (
        <Box>
            <Grid container spacing={1}>
                <Grid item xs={12} md={11}>
                    <Subtitle />
                </Grid>
                <Grid item xs={12}>
                    <Form />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Filter;
